(function () {
    'use strict';

    function questionGroupConfiguration() {
        return {
            restrict: 'E',
            templateUrl: 'siteConfiguration/directives/templates/questionGroupConfiguration.html',
            link: function (scope) {

            }
        };
    }

    questionGroupConfiguration.$inject = [];

    angular.module('ecap.siteConfiguration').directive('questionGroupConfiguration', questionGroupConfiguration);
})();
